import type { DelayEvidenceEpisode } from "../types";

export const delayEvidenceEpisodes: DelayEvidenceEpisode[] = [
  {
    id: "shift-20260724",
    date: "Jul 24, 2026",
    day: "Friday",
    time: "18:05",
    primaryDish: "Jjamppong",
    durationMinutes: 28,
    delayMinutes: 8,
    similarity: 0.91,
    concurrentDishes: ["Jajangmyeon", "Tangsuyuk", "Yurinji"],
    workforce: "A · pork at Gas Range / B · first fry / C · seafood wash",
    condition: "Three concurrent tickets and only one worker available for vegetable prep.",
    response: "Moved Worker A to the cutting station before the next wok cycle.",
    outcome: "Prep queue recovered in 6 min; later tickets avoided another 8 min delay.",
  },
  {
    id: "shift-20260717",
    date: "Jul 17, 2026",
    day: "Friday",
    time: "18:11",
    primaryDish: "Jajangmyeon",
    durationMinutes: 26,
    delayMinutes: 7,
    similarity: 0.89,
    concurrentDishes: ["Jjamppong", "Tangsuyuk", "Fried Rice"],
    workforce: "A · wok / B · fryer / C · plating",
    condition: "Onion and cabbage portions fell below two orders during the dinner ramp.",
    response: "Pre-portioned six vegetable batches and held the fryer assignment.",
    outcome: "Average ready time fell from 26 to 19 min over the next four tickets.",
  },
  {
    id: "shift-20260710",
    date: "Jul 10, 2026",
    day: "Friday",
    time: "18:22",
    primaryDish: "Jjamppong",
    durationMinutes: 29,
    delayMinutes: 9,
    similarity: 0.87,
    concurrentDishes: ["Jajangmyeon", "Yurinji", "Mapo Tofu"],
    workforce: "A · sauce reduction / B · chicken fry / C · seafood prep",
    condition: "Gas Range reached full capacity while seafood prep occupied the sink.",
    response: "Delayed the second fry batch and cleared one wok position for soup.",
    outcome: "Prevented the queue from spreading to Plating; recovered in 9 min.",
  },
  {
    id: "shift-20260703",
    date: "Jul 3, 2026",
    day: "Friday",
    time: "18:16",
    primaryDish: "Yurinji",
    durationMinutes: 24,
    delayMinutes: 5,
    similarity: 0.86,
    concurrentDishes: ["Jjamppong", "Tangsuyuk", "Jajangmyeon"],
    workforce: "A · vegetable cut / B · second fry / C · wok",
    condition: "Dual fryer baskets were occupied and garnish prep was not ready.",
    response: "Kept Worker B at Fry and routed Worker A directly to garnish prep.",
    outcome: "Yurinji left in 24 min and the following batch left in 18 min.",
  },
  {
    id: "shift-20260626",
    date: "Jun 26, 2026",
    day: "Friday",
    time: "17:58",
    primaryDish: "Jajangmyeon",
    durationMinutes: 27,
    delayMinutes: 8,
    similarity: 0.84,
    concurrentDishes: ["Fried Rice", "Jjamppong", "Tangsuyuk"],
    workforce: "A · pork dice / B · fryer load / C · dish wash",
    condition: "Prep demand arrived 12 min earlier than the usual Friday peak.",
    response: "Started an anticipatory eight-portion vegetable batch.",
    outcome: "Recovered 4 min sooner than comparable shifts without early prep.",
  },
  {
    id: "shift-20260619",
    date: "Jun 19, 2026",
    day: "Friday",
    time: "18:31",
    primaryDish: "Tangsuyuk",
    durationMinutes: 25,
    delayMinutes: 6,
    similarity: 0.83,
    concurrentDishes: ["Jajangmyeon", "Yurinji", "Jjamppong"],
    workforce: "A · wok / B · batter and fry / C · cold prep",
    condition: "Fryer queue exceeded four items while sauce work blocked the range.",
    response: "Grouped compatible fry batches and reassigned plating to Worker C.",
    outcome: "Reduced fryer idle transitions and cleared the queue in 8 min.",
  },
  {
    id: "shift-20260612",
    date: "Jun 12, 2026",
    day: "Friday",
    time: "18:08",
    primaryDish: "Jjamppong",
    durationMinutes: 31,
    delayMinutes: 11,
    similarity: 0.82,
    concurrentDishes: ["Jajangmyeon", "Mapo Tofu", "Fried Rice"],
    workforce: "A · two wok tickets / B · fryer cleaning / C · seafood wash",
    condition: "One wok burner recovered slowly and the prep table had no spare capacity.",
    response: "Paused a low-priority fried rice ticket and prioritized seafood prep.",
    outcome: "Contained the longest delay to one ticket instead of three.",
  },
  {
    id: "shift-20260605",
    date: "Jun 5, 2026",
    day: "Friday",
    time: "18:14",
    primaryDish: "Jajangmyeon",
    durationMinutes: 26,
    delayMinutes: 7,
    similarity: 0.81,
    concurrentDishes: ["Tangsuyuk", "Jjamppong", "Yurinji"],
    workforce: "A · sauce / B · first fry / C · plate staging",
    condition: "Vegetable stock was available but had not been moved to Center Prep.",
    response: "Routed Worker C through Cold Storage to Center Prep before plating.",
    outcome: "Removed a 3 min retrieval gap from each subsequent noodle order.",
  },
];
